import { FC } from "react";
import { IllustrationWrapper } from "../IllustrationWrapper";
import { IllustrationProps } from "../Illustrations.types";

const StakePushGradientMultiplier: FC<IllustrationProps> = (allProps) => {
  const { svgProps: props, ...restProps } = allProps;
  return (
    <IllustrationWrapper
      componentName="StakePushGradientMultiplier"
      illustration={
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={restProps?.width ?? "24"}
          height={restProps?.height ?? "24"}
          viewBox="0 0 48 48"
          fill="none"
          {...props}
        >
          <path
            d="M3.92871 11.4906C3.92871 7.5265 7.14222 4.31299 11.1063 4.31299H37.125C41.089 4.31299 44.3025 7.5265 44.3025 11.4906V28.0045C44.3025 30.2919 43.2123 32.4423 41.3672 33.7942L28.3005 43.3686C27.1316 44.2251 25.7202 44.6868 24.271 44.6868C22.8432 44.6868 21.4513 44.2385 20.2919 43.4051L6.91704 33.7914C5.04094 32.4429 3.92871 30.2737 3.92871 27.9632V11.4906Z"
            fill="black"
          />
          <path
            d="M3.92871 14.0794C3.92871 10.1154 7.14222 6.90186 11.1063 6.90186H37.125C41.089 6.90186 44.3025 10.1154 44.3025 14.0794V30.5934C44.3025 32.8807 43.2123 35.0311 41.3672 36.3831L28.3005 45.9574C27.1316 46.8139 25.7202 47.2757 24.271 47.2757C22.8432 47.2757 21.4513 46.8274 20.2919 45.994L6.91704 36.3803C5.04094 35.0318 3.92871 32.8626 3.92871 30.5521V14.0794Z"
            fill="url(#paint0_linear_8470_4104)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.1064 0.5H37.1251C43.195 0.5 48.1157 5.42068 48.1157 11.4907V28.0046C48.1157 31.5071 46.4463 34.7999 43.6211 36.8701L30.5543 46.4444C28.7316 47.78 26.5308 48.5 24.2711 48.5C22.0447 48.5 19.8744 47.8009 18.0665 46.5014L4.69161 36.8877C1.81882 34.8228 0.115723 31.5012 0.115723 27.9633V11.4907C0.115723 5.42069 5.0364 0.5 11.1064 0.5ZM11.1064 4.31308C7.14231 4.31308 3.92881 7.5266 3.92881 11.4907V27.9633C3.92881 30.2738 5.04104 32.443 6.91714 33.7915L20.292 43.4052C21.4514 44.2386 22.8433 44.6869 24.2711 44.6869C25.7203 44.6869 27.1317 44.2252 28.3006 43.3687L41.3673 33.7943C43.2124 32.4424 44.3026 30.292 44.3026 28.0046V11.4907C44.3026 7.52659 41.0891 4.31308 37.1251 4.31308H11.1064Z"
            fill="url(#paint1_linear_8470_4104)"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M31.3276 41.1505L28.3005 43.3686C27.1316 44.2251 25.7202 44.6868 24.271 44.6868C22.8432 44.6868 21.4513 44.2385 20.2919 43.4051L16.9038 40.9698V18.0166H31.3276V41.1505Z"
            fill="url(#paint2_linear_8470_4104)"
            fill-opacity="0.6"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M42.4107 32.8604C42.097 33.2018 41.7482 33.515 41.3672 33.7942L33.2495 39.7423V22.5972H42.4107V32.8604Z"
            fill="url(#paint3_linear_8470_4104)"
            fill-opacity="0.6"
          />
          <path
            d="M30.8641 17.4771C30.8641 17.4771 30.408 17.3249 29.7745 17.1139C27.5894 16.3856 25.85 14.6462 25.1217 12.4612C24.9107 11.8276 24.7585 11.3715 24.7585 11.3715C24.6662 11.0948 24.4072 10.9082 24.1155 10.9082C23.8239 10.9082 23.5649 11.0949 23.4726 11.3715C23.4726 11.3715 23.3205 11.8276 23.1095 12.461C22.3812 14.6461 20.6418 16.3856 18.4568 17.1139C17.8232 17.3249 17.3671 17.4771 17.3671 17.4771C17.0904 17.5693 16.9038 17.8283 16.9038 18.12C16.9038 18.4117 17.0905 18.6707 17.3672 18.763C17.3672 18.763 17.8232 18.9151 18.4566 19.126C20.6417 19.8544 22.3812 21.5938 23.1095 23.7787C23.3205 24.4123 23.4726 24.8684 23.4726 24.8684C23.5649 25.1451 23.8238 25.3317 24.1155 25.3317C24.4072 25.3317 24.6663 25.1451 24.7585 24.8684C24.7585 24.8684 24.9107 24.4124 25.1217 23.7789C25.85 21.5938 27.5894 19.8544 29.7744 19.1261C30.408 18.9151 30.8641 18.763 30.8641 18.763C31.1407 18.6707 31.3274 18.4117 31.3274 18.12C31.3274 17.8283 31.1407 17.5693 30.8641 17.4771Z"
            fill="white"
          />
          <path
            d="M42.1165 22.1889C42.1165 22.1889 41.8268 22.0922 41.4245 21.9582C40.0366 21.4956 38.9318 20.3908 38.4692 19.003C38.3352 18.6005 38.2385 18.3109 38.2385 18.3109C38.1799 18.1351 38.0154 18.0166 37.8301 18.0166C37.6449 18.0166 37.4804 18.1352 37.4217 18.3109C37.4217 18.3109 37.3251 18.6006 37.1912 19.0029C36.7285 20.3908 35.6237 21.4956 34.2359 21.9582C33.8335 22.0922 33.5438 22.1889 33.5438 22.1889C33.368 22.2475 33.2495 22.412 33.2495 22.5973C33.2495 22.7825 33.3681 22.947 33.5438 23.0056C33.5438 23.0056 33.8335 23.1023 34.2358 23.2362C35.6237 23.6989 36.7285 24.8037 37.1911 26.1915C37.3251 26.5939 37.4217 26.8836 37.4217 26.8836C37.4804 27.0593 37.6448 27.1779 37.8301 27.1779H37.8301C38.0154 27.1779 38.1799 27.0593 38.2385 26.8836C38.2385 26.8836 38.3352 26.5939 38.4692 26.1916C38.9318 24.8037 40.0366 23.6989 41.4244 23.2363C41.8268 23.1023 42.1165 23.0056 42.1165 23.0056C42.2922 22.947 42.4108 22.7826 42.4108 22.5973C42.4108 22.412 42.2922 22.2475 42.1165 22.1889Z"
            fill="white"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.982 39.5884L6.91704 33.7914C6.5155 33.5028 6.14894 33.1766 5.8208 32.8194V22.7004H14.982V39.5884Z"
            fill="url(#paint4_linear_8470_4104)"
            fill-opacity="0.6"
          />
          <path
            d="M14.6878 22.2922C14.6878 22.2922 14.3981 22.1955 13.9958 22.0615C12.6079 21.5989 11.5031 20.4941 11.0405 19.1063C10.9065 18.7038 10.8098 18.4141 10.8098 18.4141C10.7512 18.2384 10.5867 18.1199 10.4014 18.1199C10.2161 18.1199 10.0517 18.2384 9.99302 18.4142C9.99302 18.4142 9.89642 18.7038 9.76244 19.1062C9.29981 20.4941 8.19501 21.5989 6.80719 22.0615C6.40475 22.1955 6.11507 22.2922 6.11507 22.2922C5.93933 22.3508 5.8208 22.5153 5.8208 22.7005C5.8208 22.8858 5.93936 23.0503 6.1151 23.1089C6.1151 23.1089 6.40477 23.2055 6.80707 23.3395C8.19498 23.8021 9.29982 24.9069 9.76241 26.2947C9.89642 26.6972 9.99302 26.9868 9.99302 26.9868C10.0517 27.1626 10.2161 27.2811 10.4014 27.2811H10.4014C10.5867 27.2811 10.7512 27.1626 10.8098 26.9869C10.8098 26.9869 10.9065 26.6972 11.0405 26.2948C11.5031 24.907 12.6079 23.8021 13.9957 23.3395C14.3981 23.2055 14.6878 23.1089 14.6878 23.1089C14.8635 23.0503 14.9821 22.8858 14.9821 22.7005C14.9821 22.5152 14.8635 22.3508 14.6878 22.2922Z"
            fill="white"
          />
          <defs>
            <linearGradient
              id="paint0_linear_8470_4104"
              x1="24.1156"
              y1="6.90186"
              x2="24.1156"
              y2="47.2757"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D267FC" />
              <stop offset="0.48" stopColor="#896FFF" />
              <stop offset="0.945" stopColor="#71F0B1" />
            </linearGradient>
            <linearGradient
              id="paint1_linear_8470_4104"
              x1="24.1157"
              y1="0.5"
              x2="24.1157"
              y2="48.5"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#D267FC" />
              <stop offset="0.48" stopColor="#896FFF" />
              <stop offset="0.945" stopColor="#71F0B1" />
            </linearGradient>
            <linearGradient
              id="paint2_linear_8470_4104"
              x1="24.1157"
              y1="18.0166"
              x2="24.1157"
              y2="44.6868"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A9FFEE" />
              <stop offset="1" stopColor="white" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint3_linear_8470_4104"
              x1="37.8301"
              y1="22.5972"
              x2="37.8301"
              y2="39.7423"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A9FFEE" />
              <stop offset="1" stopColor="white" stop-opacity="0" />
            </linearGradient>
            <linearGradient
              id="paint4_linear_8470_4104"
              x1="10.4014"
              y1="22.7004"
              x2="10.4014"
              y2="39.5884"
              gradientUnits="userSpaceOnUse"
            >
              <stop stopColor="#A9FFEE" />
              <stop offset="1" stopColor="white" stop-opacity="0" />
            </linearGradient>
          </defs>
        </svg>
      }
      {...restProps}
    />
  );
};

export default StakePushGradientMultiplier;
